import { Routes } from '@angular/router';
import { accesoAppGuard } from './guard/acceso-app.guard';
import { accesoLoginGuard } from './guard/acceso-login.guard';

export const routes: Routes = [
    { path: 'login', loadComponent: () => import('./auth/features/login/login.component').then(c => c.LoginComponent), canActivate: [accesoLoginGuard] },
    { path: 'login/:usersesion', loadComponent: () => import('./auth/features/login/login.component').then(c => c.LoginComponent) },
    { path: 'recuperar-clave', loadComponent: () => import('./auth/features/recover-password/recover-password.component').then(c => c.RecoverPasswordComponentMain) },
    { path: 'clave-expirada', loadComponent: () => import('./auth/features/expired-password/expired-password.component').then(c => c.ExpiredPasswordComponentMain) },
    { path: 'seleccionar-sucursal', loadComponent: () => import('./auth/features/select-branch/select-branch.component').then(c => c.SelectBranchComponentMain), canActivate: [accesoAppGuard] },
    {
        path: '', loadComponent: () => import('./layouts/features/full/full.component').then(c => c.FullComponent), canActivate: [accesoAppGuard], children: [
            { path: '', redirectTo: 'atajos', pathMatch: 'full' },
            { path: 'archivos', loadChildren: () => import('./modulos/archivos/archivos.routes') },
            { path: 'contabilidad', loadChildren: () => import('./modulos/contabilidad/contabilidad.routes') },
            { path: 'dashboard', loadChildren: () => import('./modulos/dashboard/dashboard.routes') },
            { path: 'atajos', loadComponent: () => import('./layouts/features/atajos/atajos.component') }
        ]
    },
    { path: '**', loadComponent: () => import('layout-tsi').then(m => m.NotFoundComponent) }
]
